import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-events-small',
  templateUrl: './sample-events-small.component.html',
  styleUrls: ['./sample-events-small.component.scss']
})
export class SampleEventsSmallComponent implements OnInit {

  @Input() block: any;
  @Input() isEvent: boolean = false;
  public domainWebsite = environment.urlApi;
  public isLinkEsternal: boolean = false;
  public date: any;

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.setTitle(this.block.field_titolo) ? this.nodeService.verifyLinkExternal(this.setTitle(this.block.field_titolo).link) : false;
    this.setDate();
  }

  public setLabelCategorySmall(category: any): string {
    let stingCategory: string = '';
    if (category.length > 3) {
      stingCategory = category[0].name + ', ' + category[1].name + ', ' + category[2].name + ', ' + '+' + (category.length - 3);
    } else {
      category.forEach((el: any, idx: number) => {
        if (idx === category.length - 1) {
          stingCategory += el.name;
        } else {
          stingCategory += el.name + ', ';
        }
      });
    }
    return stingCategory;
  }

  public setImage(field_image: string): string {
    return this.domainWebsite + this.nodeService.retrieveImage(field_image, 'src');
  }

  public setAltImage(field_image: string): string {
    return this.nodeService.retrieveImage(field_image, 'alt');
  }

  private setDate(): void {
    if (this.nodeService.retrieveDateTime(this.block.field_data_inizio, 'datetime') === this.nodeService.retrieveDateTime(this.block.field_data_fine, 'datetime')) {
      this.date = {
        inizio: this.nodeService.retrieveDateTime(this.block.field_data_inizio, 'datetime'),
        fine: null
      }
    } else {
      this.date = {
        inizio: this.nodeService.retrieveDateTime(this.block.field_data_inizio, 'datetime'),
        fine: this.nodeService.retrieveDateTime(this.block.field_data_fine, 'datetime')
      }
    }
  }

  public setTitle(field_titolo: string): any {
    return this.nodeService.retriveLinkTagA(field_titolo, 'a');
  }


}
